import { SchemaCatalogApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useSchemasAPI(): SchemaCatalogApi {
  return new SchemaCatalogApi(apiConfig);
}
